// extracted by css-extract-rspack-plugin
export default {"main":"h4PjC"};